export var CLIENT_SEARCH = "CLIENT_SEARCH";
export var SET_SELECTED_CLIENT = "SET_SELECTED_CLIENT";
